module.exports = __webpack_public_path__ + "img/income_stats.f2356502.png";